import { render, staticRenderFns } from "./AnnotateButtons.vue?vue&type=template&id=74970b83&scoped=true"
import script from "./AnnotateButtons.vue?vue&type=script&lang=js"
export * from "./AnnotateButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74970b83",
  null
  
)

export default component.exports